/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */
/// <reference path="../typings/custom_typings.d.ts" />

import {CommonModule} from '@angular/common';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';

import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';

import {initializer} from './app-initializer';
import {AppComponent} from './app.component';
import {ROUTES} from './app.routes';
import {ChatbotModule} from './chatbot/chatbot.module';
import {DashboardModule} from './dashboard/dashboard.module';
import {Destroyable} from './destroyable.component';
import {InboxModule} from './inbox/inbox.module';
import {LoginModule} from './login/login.module';
import {ProcessReplyEmailModule} from './process-reply-email/process-reply-email.module';
import {AuthenticationService} from './shared/authentication';
import {KeycloakWrapperService} from './shared/authentication/keycloak-wrapper.service';
import {I18nManager, WebpackTranslateLoader} from './shared/i18n/i18n.module';
import {LocalizationModule} from './shared/localization/localization.module';
import {GPTranslateService} from './shared/localization/translate.service';
import {SharedModule} from './shared/shared.module';
import {TemplateManagementModule} from './template-management/template-management.module';
import {WorkflowsModule} from './workflows/workflows.module';
import {SdconnectAdminModule} from "./sdconnect-admin/sdconnect-admin.module";

import {IdleSessionService} from '@gp/shared/authentication/idle.service';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {environment} from '../environments/environment';



export function translateLoader(httpClient, authenticationService) {
  return new WebpackTranslateLoader(httpClient, authenticationService);
}

@NgModule({
  imports: [
    RouterModule.forRoot(ROUTES, {useHash: true}),
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    KeycloakAngularModule,
    SharedModule,
    LoginModule,
    DashboardModule,
    TemplateManagementModule,
    InboxModule,
    WorkflowsModule,
    ProcessReplyEmailModule,
    LocalizationModule,
    BrowserAnimationsModule,
    ChatbotModule,
    SdconnectAdminModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (translateLoader),
        deps: [HttpClient, AuthenticationService]
      }
    })
  ],
  declarations: [
    AppComponent,
    Destroyable
  ],
  exports: [
    LocalizationModule
  ],
  bootstrap: [AppComponent],
  providers: [
    {provide: 'GP_API_HOST', useFactory: () => environment.API_URL},
    {provide: TranslateService, useExisting: GPTranslateService},
    I18nManager,
    KeycloakWrapperService,
    IdleSessionService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      multi: true,
      deps: [KeycloakService, HttpClient]
    }
    // see ui/src/app/shared/api/request-interceptor.ts
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: RequestInterceptor,
    //   multi: true
    // }
  ]
})

export class AppModule {
}
